const storeProjectId: string | null = localStorage.getItem('projectId');



export const initialValuesOpportunities = {
    projectId: storeProjectId,
    opportunityDetailsDescription: {
        projectId: storeProjectId,
        description: '',
        analysis: '',
        status: '',
        statusDetails: '',
        jobType: '',
        saleAmount: 0,
        leadSource: '',
        sourceDescription: '',
        adCode: ''
    },
    opportunityDetailsPropertyAddress: {
        projectId: storeProjectId,
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: ''
    },
    opportunityDetailsSitution: {
        generalBackground: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }

        ],
        clientpastHomeRenvExp: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ],
        clientReasonForProject: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ],
        projectBackground: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ]
    },
    opportunityDetailsScopeDTO: {
        opportunityScop: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ],
        additionScope: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ],
        detailedScope: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ]
    },
    opportunityDetailsPDMCheckInDTO: {
        pdmCheckIn: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ]
    },
    opportunityDetailsArchitecturalReviewDTO: {
        architecturalReview: [
            {
                projectId: storeProjectId,
                surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                name: '',
                // surveyKey: 0,
                surveyResultRevised: '',
                surveyResultOriginal: '',
                fieldType: '',
                sectionId: 0,
                subSectionId: 0
            }
        ]
    },
    opportunityDetailsAppointment: {
        id: "410c9584-63db-4fef-99a1-7b72dbe32b6c",
        firstContactDate: "",
        firstAptDate: "",
        appointmentMaker: ""
    }
}